export default {
  data() {},
  methods: {
    wxPay(id, diff_pay) {
      var isUser = localStorage.getItem("BLHuser");
      var mallid = localStorage.getItem("mallid");
      var root = process.env.ORDER_URL;
      const tag = this.$common.getUserAgent() == "H5" ? 1 : 2; // 1 h5 2 微信

      this.$api.post(
        "order/orders/pay",
        {
          id_example: mallid,
          token_user: isUser,
          id_order: id,
          pay_type: this.$store.state.webCount.buy_point,
          tag: tag, // 1 h5 2 微信
          diff_pay
        },
        res => {
          if (res.data.code == "100") {
            this.$router.push({
              name: "OrderSucceed",
              query: { orderId: res.data.data }
            });
            this.btn = false;
          } else if (res.data.code == "200") {
            if (res.data.data == "point#500") {
              this.$dialog
                .confirm({
                  title: "提示",
                  message: "积分不足，是否补齐差价？"
                })
                .then(() => {
                  this.wxPay(id, 1);
                })
                .catch(() => {
                  // on cancel
                });

              return;
            }

            if (this.$common.getUserAgent() == "H5") {
              window.location.href = res.data.data.pay.h5;
              return;
            }

            var backurl =
              window.location.origin +
              "/ordersucceed?orderId=" +
              res.data.data.order_number;
            backurl = encodeURIComponent(backurl);
            var errback =
              window.location.origin + "/user/myorder/allorder?type=0";
            errback = encodeURIComponent(errback);
            const appid = localStorage.getItem('login_code')
            window.location.href = `${root}?id=${
              res.data.data.pay.log_id
            }&token_user=${isUser}&id_example=${mallid}&appid=${appid}&reurl=${backurl}&err=${errback}`;
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({ name: "NoteLogin" });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
              this.btn = false;
            }
          }
        },
        err => {
          this.$router.push({ name: "Overtime" });
        }
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/pay.js